import { render, staticRenderFns } from "./CarriersLayout.vue?vue&type=template&id=8dd60aba&"
import script from "./CarriersLayout.vue?vue&type=script&lang=js&"
export * from "./CarriersLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports